export const COLOR_SWATCHES = [
  "#25262B",
  "#FA5252",
  "#E64980",
  "#BE4BDB",
  "#682BCB", // default track color
  "#4C6EF5",
  "#228BE6",
  "#15AABF",
  "#12B886",
  "#40C057",
  "#FAB005",
  "#FD7E14",
];
